<template>
  <div class="exception-container">
    <div class="img-block">
      <div class="img" :class="imgClass"></div>
    </div>
    <div class="content">
      <h1>{{ code }}</h1>
      <div class="desc">{{ desc }}</div>
      <a-button type="primary" @click="backToHome">返回首页</a-button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ExceptionPage',

  mounted() {
    switch (this.$route.name) {
      case '403':
        this.code = '403'
        this.desc = '抱歉，你无权访问该页面'
        this.imgClass = 'img403'
        break
      case '404':
        this.code = '404'
        this.desc = '抱歉，你访问的页面不存在'
        this.imgClass = 'img404'
        break
      case 'p404':
        this.code = '404'
        this.desc = '抱歉，你访问的页面不存在'
        this.imgClass = 'img404'
        break
      case '500':
        this.code = '500'
        this.desc = '抱歉，服务器出错了'
        this.imgClass = 'img500'
        break
      default:
        break
    }
  },

  data() {
    return {
      code: '',
      desc: '',
      imgClass: ''
    }
  },

  methods: {
    backToHome() {
      this.$router.replace('/')
    }
  }
}
</script>

<style lang="scss" scoped>
.exception-container {
  display: flex;
  box-sizing: border-box;
  min-height: 500px;
  height: 80%;
  align-items: center;
  .img-block {
    flex: 0 0 50%;
    text-align: center;
    .img {
      height: 360px;
      width: 100%;
      max-width: 430px;
      float: right;
      background-repeat: no-repeat;
      background-position: 50% 50%;
      background-size: 100% 100%;
      &.img403 {
        background-image: url('../../../assets/images/403.svg');
      }
      &.img404 {
        background-image: url('../../../assets/images/404.svg');
      }
      &.img500 {
        background-image: url('../../../assets/images/500.svg');
      }
    }
  }
  .content {
    flex: auto;
    padding-left: 100px;
    h1 {
      color: #434e59;
      font-size: 72px;
      font-weight: 600;
      line-height: 72px;
      margin-bottom: 24px;
    }
    .desc {
      color: rgba(0, 0, 0, 0.45);
      font-size: 20px;
      line-height: 28px;
      margin-bottom: 16px;
    }
  }
}
</style>
